import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import {
  selectCreditCard,
  selectCreditCardIdFromRoute,
  selectCreditCardPermissions,
  selectDeletingCreditCardFromState,
} from 'src/app/DeactivateBudget/redux/deactivateBudget.selectors'
import ConfirmationPopupContent from 'src/components/ConfirmationPopupContent/ConfirmationPopupContent'
import NotFoundPopupContent from 'src/components/NotFoundPopupContent/NotFoundPopupContent'
import Popup from 'src/components/Popup/Popup'
import { useFlyoutDispatch } from 'src/hooks'
import Trns from 'src/localization/Trns'
import {
  deactivateCreditCardAndCloseModal,
  getCreditCard,
  getCreditCardPermissions,
} from 'src/redux/actions/data/creditCards.actions'

const DeactivateBudget: React.FC = () => {
  const creditCardId = useSelector(selectCreditCardIdFromRoute)
  const creditCard = useSelector(selectCreditCard)
  const creditCardPermissions = useSelector(selectCreditCardPermissions)
  const deletingCreditCard = useSelector(selectDeletingCreditCardFromState)
  const { analytics } = useAnalyticsContext()

  const dispatch = useFlyoutDispatch()
  const showDeactivateDeleteButton =
    creditCard !== undefined &&
    creditCard.isBudget &&
    creditCardPermissions?.canDestroy

  useEffect(() => {
    dispatch(getCreditCard(creditCardId))
    dispatch(getCreditCardPermissions(creditCardId))
  }, [creditCardId])

  return (
    <Popup>
      {showDeactivateDeleteButton ? (
        <ConfirmationPopupContent
          title={<Trns source={'Deactivate'} />}
          subtitle={
            <Trns
              source={'Deactivate the budget ${budgetName}?'}
              expressions={{
                budgetName: <span>{creditCard.truncatedDisplayName}</span>,
              }}
            />
          }
          actionButtonLabel={<Trns source={'Deactivate'} />}
          actionButtonLoading={deletingCreditCard}
          actionButtonOnClick={(): void => {
            analytics?.track('confirm deactivate budget', {
              budget_id: creditCard.id,
              issuer: creditCard.issuer,
            })
            dispatch(
              deactivateCreditCardAndCloseModal(creditCard.id, creditCard),
            )
          }}
          cancelButtonLabel={<Trns source={'Cancel'} />}
        />
      ) : (
        <NotFoundPopupContent />
      )}
    </Popup>
  )
}

export default DeactivateBudget
